import { useEffect } from 'react';

export const useEffectOnlyOnce = (func: any) => {
  return useEffect(func, []);
};
